<template>
<div :class="{'d-none' : !this.$parent.$parent.$parent.step2}">
    <form action=""  v-on:submit.prevent="validateForm()" class="needs-validation">
        <div class=" mt-4 mb-4">
            <div class="col">
                <p class="mx-3 my-4" v-if="billsRequired == 6">To get your rebate, you’ll need to supply <strong>six (6) months’ worth of bills</strong> from a participating provider.  Bills must include Paramount+ with SHOWTIME as a paid service for each of the six (6) months.  Bills can be submitted in PDF, JPG or PNG formats.  Rebate may only apply once, subject to provider rules.</p>
                <p class="mx-3 my-4" v-else>To get your rebate, you’ll need to supply <strong>three (3) months’ worth of bills</strong> from a participating provider.  Bills must include Paramount+ with SHOWTIME as a paid service for each of the three (3) months.  Bills can be submitted in PDF, JPG or PNG formats.  Rebate may only apply once, subject to provider rules.</p>
                <div class="form-group no-gutters peak-sans">
                    <div class="col-12 text-center">
                     <h4 class="text-red mb-5 peak-sans text-bold">CLAIM YOUR <strong>${{rebate.amount}}</strong> PARAMOUNT+ WITH SHOWTIME REBATE</h4>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label for="first_name" class="form-control-label mb-0 col-md-12">*First Name</label>
                            <div class="col-md-12 mb-3">
                                <input type="text" class="form-control" placeholder="First Name"  v-model="customer.first_name" required name="name">
                            </div>
                            <div class="invalid-feedback">
                                Please enter your first name.
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="last_name" class="form-control-label mb-0 col-md-12">*Last Name</label>
                            <div class="col-md-12 mb-3">
                                <input type="text" class="form-control" placeholder="Last Name" v-model="customer.last_name" required name="last_name">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group no-gutters">
                    <div class="row">
                        <div class="col-md-6">
                            <label for="first_name" class="form-control-label mb-0 col-md-12">*Email Address</label>
                            <div class="col-md-12">
                                <input type="email" class="form-control" placeholder="email@email.com" maxlength="191" v-model="customer.email" required name="email">
                            <small style="line-height:1em;">Please choose the email to which you'd like your rebate to sent.</small>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="first_name" class="form-control-label mb-0 col-md-12">*Confirm Email Address</label>
                            <div class="col-md-12">
                                <input type="email" class="form-control" placeholder="email@email.com" maxlength="191" v-model="customer.email_confirmation" required name="confirmemail">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <file-management ref="FileManagement" :currentAttachments="[]"> </file-management>
        <div class="form-group col-md-10">
            <div class="d-flex no-gutters col-12 mb-3">
                    <div class="col-1 mb-3 mr-1">
                        <input type="checkbox" class="form-control form-check w-75" id="billsCheckbox"  v-model="billsCheck" required>
                    </div>
                    <label for="billsCheckbox" class="form-control-label mb-0 pt-1 text-dark text-initial" style="text-transform:none"  v-if="billsRequired == 6">I confirm I have six (6) months’ worth of bills from a participating provider showing paid Paramount+ with SHOWTIME service. </label>
                    <label for="billsCheckbox" class="form-control-label mb-0 pt-1 text-dark text-initial" style="text-transform:none" v-else>I confirm I have three (3) months’ worth of bills from a participating provider showing paid Paramount+ with SHOWTIME service. </label>
            </div>

            <div class="d-flex no-gutters col-12">
                <div class="col-1 mb-3 mr-1">
                    <input type="checkbox" class="form-control form-check w-75" id="termsCheckbox" v-model="termsCheck" required>
                </div>
                <label for="termsCheckbox" class="form-control-label mb-0 pt-2 text-dark text-initial" style="text-transform:none">I confirm I have reviewed the <a href="/terms" target="_blank">terms of service</a> for the Paramount+ with SHOWTIME rebate program.</label>
            </div>
        </div>
        <div class=" mt-4 mb-4">
            <div class="col">
                <div class="">
                    <div class="col text-center">
                        <button type="submit" class="show-btn">SUBMIT</button>
                    </div><!--col-->
                </div><!---->
            </div>
        </div>
    </form>
  </div>
</template>
<script>
import FileManagement from './FileManagement.vue';

export default {
    mounted(){

    },
    props:{
        provider: Object,
    },

    data() {
        return {
            payload: new FormData(),
            customer: {
                first_name: '',
                last_name: '',
                email: '',
                email_confirmation: '',
            },
            rebate:{
                amount:25.00,
                attachments: []
            },
            mvpdinfo:{
                account_number:'',
            },
            billsCheck:false,
            termsCheck:false,
            noBillCheck:false,
            noTermsCheck:false,
        }
    },
    methods: {
        validateForm(){
            if(!this.billsCheck || !this.termsCheck){

            } else {
                this.clearPayload();
            }
        },
        prepareRebate() {
            this.$store.commit('SHOW_ERRORS',{});
            console.log('PREPARING!')
            this.payload.append('first_name',  this.customer.first_name);
            this.payload.append('last_name',  this.customer.last_name);
            this.payload.append('email',  this.customer.email);
            this.payload.append('email_confirmation',  this.customer.email_confirmation);
            this.payload.append('amount', this.rebate.amount);
            this.payload.append('mvpd', this.provider.name);
            this.payload.append('account_number', 3);
            if( this.$refs.FileManagement.validate()){
                this.$refs.FileManagement.prepareFiles()
                this.createRebate();
            };
        },
        createRebate(){
            this.$store.dispatch('createNewRebate', this.payload);
        },
        clearPayload(){
            for (var key of this.payload.keys()) {
                console.log('clearing!');
                this.payload.delete(key)
            };
            this.prepareRebate()
        }
        // attachUpload(){
        //     this.rebate.files.push(this.$refs.file.files[0])
        // }
    },
    computed: {
        billsRequired() {
            return this.$store.state.billsRequired
        }
    },

    components:{
        FileManagement
    }
 }
</script>
